const WhatTheWorldNeedsNowIsLove = [
	'What the world needs now is love, sweet love',
	"It's the only thing that there's just too little of",
	'What the world needs now is love, sweet love',
	'No, not just for some but for everyone',
	'',
	"Lord, we don't need another mountain",
	'There are mountains and hillsides enough to climb',
	'There are oceans and rivers enough to cross',
	"Enough to last 'til the end of time",
	'',
	'What the world needs now is love, sweet love',
	"It's the only thing that there's just too little of",
	'What the world needs now is love, sweet love',
	'No, not just for some but for everyone',
	'',
	"Lord, we don't need another meadow",
	'There are cornfields and wheat fields enough to grow',
	'There are sunbeams and moonbeams enough to shine',
	'Oh listen, Lord, if you want to know',
	'',
	'What the world needs now is love, sweet love',
	"It's the only thing that there's just too little of",
	'What the world needs now is love, sweet love',
	'No, not just for some oh but just for every, everyone',
	'',
	'What the world needs now is love, sweet love (Oh, is love)',
	'What the world needs now is love, sweet love (Oh, is love)',
	'What the world needs now is love, sweet love (Oh, is love)',
];

export default WhatTheWorldNeedsNowIsLove;
